module.exports = __webpack_public_path__ + "static/media/09-06.a457f9f4.png";